module.exports = __webpack_public_path__ + "img/seller-msds.342d64f5.svg";